/**
 * WB4 Wave 1 — idempotency guard for finance reversal record+post paths.
 * Prevents duplicate revision snapshots when stream success and kernel dispatch both fire.
 */

const recordedKeys = new Set<string>();

export function buildFinanceReversalIdempotencyKey(
  sourceVoucherId: string,
  streamId?: string
): string {
  const voucher = sourceVoucherId.trim();
  const stream = streamId?.trim();
  return stream ? `${voucher}:${stream}` : `kernel:${voucher}`;
}

/** Returns true when this caller may proceed with record/post. */
export function claimFinanceReversalRecording(key: string): boolean {
  if (recordedKeys.has(key)) {
    return false;
  }
  recordedKeys.add(key);
  return true;
}

export function releaseFinanceReversalRecording(key: string): void {
  recordedKeys.delete(key);
}

/** Test-only reset. */
export function clearFinanceReversalRecordingClaims(): void {
  recordedKeys.clear();
}
